/**
 * Web-component bundle stylesheet. Imports the SAME source-of-truth
 * Tailwind layer + theme tokens that the iframe build uses, so a
 * change to `app/globals.css` shows up in both delivery modes
 * without duplication.
 *
 * Vite compiles this file via `@tailwindcss/vite`, then we strip
 * the result out at build time and inline it into the JS bundle
 * as a string (`?inline`) so the web component can `replaceSync`
 * it into the Shadow DOM's adopted-stylesheets list.
 */
@import "../app/globals.css";
